<template>
	<Dialog
		:dialog-visible="dialog"
		:title="title"
		:message="message"
		:agree-text="agreeText"
		:cancel-text="cancelText"
		:is-angry="isAngry"
		:remove-cancel-button="removeCancelButton"
		:remove-agree-button="removeAgreeButton"
		:persistent-dialog="persistentDialog"
		:custom-button="showCustomButton"
		:custom-text="customButtonText"
		:custom-button-variant="customButtonVariant"
		:custom-button-color="customButtonColor"
		:custom-button-before-agree="customButtonBeforeAgree"
		:options="options"
		@cancel="cancel"
		@agree="agree"
		@customAction="customAction">
	</Dialog>
</template>

<script>
	import Dialog from "./Dialog.vue";

	export default {
		components: {
			Dialog
		},
		data: () => ({
			dialog: false,
			resolve: null,
			reject: null,
			currentPrompt: null,
			message: null,
			requireDeleteConfirmation: false,
			deleteConfirmationText: null,
			title: null,
			agreeText: "OK",
			cancelText: "Cancel",
			isAngry: false,
			removeCancelButton: false,
			removeAgreeButton: false,
			persistentDialog: false,
			showCustomButton: false,
			customButtonText: "",
			customButtonVariant: "flat",
			customButtonColor: "primary",
			cancelResolveValue: false,
			customResolveValue: false,
			customButtonBeforeAgree: false,
			options: {
				width: "500px"
			}
		}),
		methods: {
			open(
				title,
				message,
				requireDeleteConfirmation,
				agreeText,
				cancelText,
				isAngry,
				removeCancelButton,
				options = {
					width: "500px"
				}
			) {
				this.dialog = true;
				this.title = title || "Are you sure?";
				this.agreeText = agreeText || "OK";
				this.cancelText = cancelText || "Cancel";
				this.message = message || "You can't undo this. Are you sure you want to continue?";
				this.isAngry = isAngry || false;
				this.requireDeleteConfirmation = requireDeleteConfirmation;
				this.removeCancelButton = removeCancelButton || false;
				// A prompt whose primary action can't succeed removes the agree button entirely and
				// carries its action on the custom button instead (see INVALID_CHANGES_DIALOG_OPTIONS).
				this.removeAgreeButton = options.removeAgreeButton || false;
				this.persistentDialog = options.persistent || false;
				this.showCustomButton = options.customButton || false;
				this.customButtonText = options.customText || "";
				this.customButtonVariant = options.customButtonVariant || "flat";
				this.customButtonColor = options.customButtonColor || "primary";
				this.cancelResolveValue = options.cancelResolveValue !== undefined ? options.cancelResolveValue : false;
				// Defaults to false so the three-way unsaved-changes prompt keeps resolving "Don't save"
				// as false; a prompt where the custom button IS the affirmative action opts into true.
				this.customResolveValue = options.customResolveValue !== undefined ? options.customResolveValue : false;
				this.customButtonBeforeAgree = options.customButtonBeforeAgree || false;
				this.options = options;
				const prompt = new Promise((resolve, reject) => {
					this.resolve = resolve;
					this.reject = reject;
				});
				this.currentPrompt = prompt;
				return prompt;
			},
			// Promise identity prevents one feature from dismissing another feature's shared prompt.
			dismissIfCurrent(prompt) {
				if (!this.dialog || this.currentPrompt !== prompt) return false;
				this.cancel();
				return true;
			},
			deleteOpen(title, message) {
				return this.open(title, message, false, "Delete", "Cancel", true);
			},
			agree() {
				this.resolve(true);
				this.dialog = false;
			},
			cancel() {
				this.dialog = false;
				this.resolve(this.cancelResolveValue);
			},
			customAction() {
				this.dialog = false;
				this.resolve(this.customResolveValue);
			}
		}
	};
</script>
